export enum SelectedPlatformInfo {
  NONE = 'NONE',
  WAITING = 'WAITING',
  ELAPSED = 'ELAPSED',
  TARGET = 'TARGET'
}
